import SlTooltip from "@shoelace-style/shoelace/dist/components/tooltip/tooltip";
import { BaseElement } from "../BaseElement";
import { TemplateResult, html } from "lit";
import { v4 as uuidv4 } from "uuid";

export function wrapWithTooltipAndHelp(
    root: BaseElement,
    element: TemplateResult,
    helpMsg: string
) {
    const id = uuidv4();
    return html`
        <sl-tooltip class="editor-grid-item help-wrapped-element" id=${id} .content=${helpMsg}>${element}</sl-tooltip
        ><sl-icon-button
            name="question-circle"
            class="editor-grid-item"
            @blur=${() => {
                const tooltip = root.shadowRoot?.getElementById(id) as SlTooltip;
                if (tooltip && tooltip.open) {
                    tooltip.hide();
                }
            }}
            @click=${() => {
                const tooltip = root.shadowRoot?.getElementById(id) as SlTooltip;
                if (tooltip) {
                    if (tooltip.open) {
                        tooltip.hide();
                    } else {
                        tooltip.show();
                    }
                }
            }}
        ></sl-icon-button>
    </div>`;
}
